module.exports = new __parcel__URL__("ui-jsw-compass-crossflow.0545e2c1.svg").toString();